import { useQuery } from "@tanstack/react-query";
import { getAutoBonusOptions } from "./";

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const useBonusOptions = () =>
  useQuery({
    queryKey: ["getBonusOptions"],
    queryFn: () => getAutoBonusOptions(),
    refetchOnMount: false,
    retry: false,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });
